<template lang="pug">
  .main-footer
    .container
      .main-footer__main
        .main-footer__logo
          img(src="@/assets/images/logo/logo-white.svg")
        .main-footer__contacts
          .contacts
            h4.contacts__title Контакты
            ul.contacts__list
              li.contacts__item ул. Сафьян, д.5, Казань, Респ. Татарстан, 420021
              li.contacts__item
                a(href="http://minmol.tatarstan.ru/" target="_blank") minmol.tatarstan.ru
              li.contacts__item e-mail:
                a(href="mailto:mcrt.org@gmail.com") mcrt.org@gmail.com
              li.contacts__item
                a(href="tel:+78432318119") 8 (843) 231-81-19
              li.contacts__item
                a(href="tel:+78432318129") 8 (843) 231-81-29

        .main-footer__social-networks
          social-networks
      .main-footer__copyright © 2020, Министерство по делам молодежи РТ. Все права защищены


</template>

<script>
import SocialNetworks from "../social-networks/social-networks";
export default {
  name: "main-footer",
  components: { SocialNetworks },
  data() {
    return {
      contacts: ["", "", "", "8 (843) 222-91-50"],
    };
  },
};
</script>
